import React from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import appConfig from "configs/app.config";
import useAuth from "utils/hooks/useAuth";
import { useSelector } from "react-redux";

const { authenticatedEntryPath } = appConfig;
import { Environment, getEnvironment } from "utils/getEnvironment";
import { isTokenExpired } from "../../utils/validateToken";

const websiteUrl = getEnvironment(Environment.DEVELOPMENT)
  ? "http://localhost:5173/playground"
  : import.meta.env.VITE_APP_ENV === "staging"
  ? "https://d3nez87f1dbwih.cloudfront.net/playground"
  : "https://autogon.ai/playground";

const PublicRoute = () => {
  const { authenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const playgroundAuth = searchParams.get("authorization");
  const { token } = useSelector((state) => state.auth.session);

  if (authenticated && playgroundAuth) {
    const isExpiredToken = isTokenExpired(token);
    if (isExpiredToken) {
      return;
    } else {
      window.location.assign(`${websiteUrl}?token=${token}`);
    }
  }


  return authenticated ? <Navigate to={authenticatedEntryPath} /> : <Outlet />;
};

export default PublicRoute;
